module.exports = __webpack_public_path__ + "img/李永涛.3001780d.jpg";